import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/redux/hooks";
import { type UniversityId, universities } from "../data/universityRegistry";
import StepHeader from "../StepHeader";

interface Props {
    onSelectUniversity: (universityId: UniversityId) => void;
}

export default function ChooseUniversity({ onSelectUniversity }: Props) {
    const { t } = useTranslation();
    const { locale } = useAppSelector((state) => state);

    return (
        <div className="flex flex-col items-center gap-y-6">
            <StepHeader
                title={t("dream_university_title")}
                subtitle={t("dream_university_subtitle")}
            />

            <div className="w-full max-w-md flex flex-col gap-3">
                {universities.map((uni) => (
                    <button
                        key={uni.id}
                        onClick={() => onSelectUniversity(uni.id)}
                        className="w-full flex items-center justify-between gap-4 p-5 bg-white border-2 border-gray-200 rounded-2xl hover:border-theme-500 hover:shadow-lg transition-all duration-200 group"
                    >
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 bg-theme-100 rounded-xl flex items-center justify-center group-hover:bg-theme-200 transition-colors text-2xl">
                                {uni.emoji}
                            </div>
                            <span className="text-lg font-semibold text-gray-900 text-start">
                                {t(uni.nameKey)}
                            </span>
                        </div>
                        {locale.isRTL ? (
                            <ChevronLeft className="w-5 h-5 text-gray-400 group-hover:text-theme-700 transition-colors shrink-0" />
                        ) : (
                            <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-theme-700 transition-colors shrink-0" />
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
}
